var _defs, _path, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManufacturing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "manufacturingGradient",
    x1: 0,
    y1: 0,
    x2: 96,
    y2: 96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF7A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFD76A"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "manufacturingGlow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 60V40L38 50V40L58 50V36L78 46V60H18Z",
    stroke: "url(#manufacturingGradient)",
    strokeWidth: 3,
    strokeLinejoin: "round",
    filter: "url(#manufacturingGlow)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 22,
    width: 10,
    height: 20,
    rx: 2,
    fill: "url(#manufacturingGradient)",
    filter: "url(#manufacturingGlow)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 48,
    width: 10,
    height: 12,
    rx: 2,
    fill: "url(#manufacturingGradient)",
    opacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManufacturing);
export default __webpack_public_path__ + "static/media/manufacturing.ec893183333595c46ad102dc7e2b68e4.svg";
export { ForwardRef as ReactComponent };